import { LanguageCode } from '../../../models/LanguageCode';
import { Language } from '../../../models/Language';
import { I18nUtil } from '../../../utils/i18n/I18nUtil';

export class HeadLinkService {
  private mutationObservers: MutationObserver[] = [];

  observeLinksAndHead(callback: () => void) {
    const links = document.querySelectorAll('link[rel=alternate]');
    links.forEach((l) => {
      const m = new MutationObserver(callback);
      m.observe(l, { attributes: true });
      this.mutationObservers.push(m);
    });

    const h = new MutationObserver(callback);
    const head = document.querySelector('head');
    h.observe(head, { childList: true, subtree: true });
    this.mutationObservers.push(h);
  }

  disconnectObservers() {
    this.mutationObservers.forEach((m) => m.disconnect());
    this.mutationObservers = [];
  }

  static readLinksFromHead(): Language[] {
    const tags = document.querySelectorAll('head link[rel=alternate]');
    return Array.from(tags)
      .filter((t) => t.getAttribute('hreflang')
        && t.getAttribute('hreflang').toLowerCase() !== 'x-default'
        && t.getAttribute('href'))
      .map((t) => ({
        code: t.getAttribute('hreflang').toLowerCase() as LanguageCode,
        label: I18nUtil.mapLangCodeToLocalName(t.getAttribute('hreflang').toLowerCase() as LanguageCode),
        href: t.getAttribute('href'),
      }));
  }
}
